import { WebSocketKeys } from "components/WebSocket/queryKeys";
import { useTypedQuery } from "hooks";

export const useWebSocketStatus = () => ({
  isConnected: useTypedQuery({ queryKey: WebSocketKeys.webSocketStatus, initialData: { isConnected: false } }).data.isConnected
});
